// @flow

export { default } from './BookingSectionTitle';
